"use strict";
/**
 * Post a **platform / Nucleus / Handshake charge** ledger entry when an invoice is paid.
 *
 * ## Treatment (Pheng / HAN-410 / HAN-420)
 * Platform fee is **not** a sales-invoice line. On each client payment:
 * - Dr {@link AccountingAccountMappingSlot.HANDSHAKE_PLATFORM_FEE} (charges)
 * - Cr bank:
 *   - Nucleus → {@link AccountingAccountMappingSlot.HANDSHAKE_ESCROW_BANK} (clearing)
 *   - Handshake → {@link AccountingAccountMappingSlot.HANDSHAKE_ACTUAL_BANK}
 *
 * ## Trigger
 * Project invoice marked **paid** (Finmo pay-in / markAsPaid) for Nucleus or Handshake when
 * ACCREC create used `platformFeeAsBankCharge`.
 *
 * ## Idempotency
 * `project_invoice_platform_charge:{projectInvoiceId}:{suffix}` — one entry per payment event.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTING_PLATFORM_CHARGE_SYNC_IDEMPOTENCY_PREFIX = exports.ACCOUNTING_SYNC_OPERATION_RECORD_PLATFORM_CHARGE = void 0;
exports.parseProjectInvoicePlatformChargeIdempotencyKey = parseProjectInvoicePlatformChargeIdempotencyKey;
exports.buildAccountingPlatformChargeIdempotencyKey = buildAccountingPlatformChargeIdempotencyKey;
exports.isRecordPlatformChargeAccountingSyncOp = isRecordPlatformChargeAccountingSyncOp;
exports.ACCOUNTING_SYNC_OPERATION_RECORD_PLATFORM_CHARGE = "RECORD_PLATFORM_CHARGE";
exports.ACCOUNTING_PLATFORM_CHARGE_SYNC_IDEMPOTENCY_PREFIX = "project_invoice_platform_charge:";
const PROJECT_INVOICE_PLATFORM_CHARGE_KEY_UUID = /^project_invoice_platform_charge:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}):(.+)$/i;
function parseProjectInvoicePlatformChargeIdempotencyKey(idempotencyKey) {
    const match = idempotencyKey.match(PROJECT_INVOICE_PLATFORM_CHARGE_KEY_UUID);
    if (!match) {
        return null;
    }
    return { projectInvoiceId: match[1], idempotencySuffix: match[2] };
}
function buildAccountingPlatformChargeIdempotencyKey(projectInvoiceId, idempotencySuffix) {
    return `${exports.ACCOUNTING_PLATFORM_CHARGE_SYNC_IDEMPOTENCY_PREFIX}${projectInvoiceId}:${idempotencySuffix}`;
}
function isRecordPlatformChargeAccountingSyncOp(operation) {
    return operation === exports.ACCOUNTING_SYNC_OPERATION_RECORD_PLATFORM_CHARGE;
}
